import React from 'react';
import {
    Backdrop,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Container,
    Divider,
    Grid,
    Snackbar,
    TextField,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import Alert from '@material-ui/lab/Alert';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import TeknisyenKocuDialog from 'src/components/TeknisyenKocuPopUp';
import axios from 'src/utils/axios';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2)
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 1,
        color: '#fff',
    },
    autocompleteFix: {
        "& .MuiAutocomplete-endAdornment": {
            top: "50%",
            transform: "translateY(-50%)",
        }
    },
    centerText: {
        textAlign: "center"
    },
    mt1: {
        marginTop: theme.spacing(1)
    },
    button: {
        marginTop: theme.spacing(2)
    }
}));


const TeknisyenKocuChat = () => {
    const classes = useStyles();

    const [productsData, setProductsData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productInputValue, setProductInputValue] = useState("");
    const [teknisyenKocuPopUp, setTeknisyenKocuPopUp] = useState(false);
    const [bankNoInput, setBankNoInput] = useState("");

    const [productLoading, setProductLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = useState('info');
    const [responseMessage, setResponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    const handleGetProductsBySearchTerm = (searchTerm) => {
        setProductLoading(true);
        axios.get(`/GetProductsBySearchTerm/${searchTerm}`)
            .then((response) => {
                setProductsData(response.data);
                setProductLoading(false);
            })
            .catch(() => setProductLoading(false));
    };

    const handleChangeSelectedProduct = (event, newValue) => {
        setSelectedProduct(newValue);
        if (newValue) {
            const userModelCode = newValue.KUL_MODEL_KODU;
            setLoading(true);

            axios.get(`/GetBankNumbersRelatedReceipts/${"-1"}/${userModelCode}`)
                .then((response) => {
                    const data = response.data || [];
                    setBankNoInput(data.toString());
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false)
                });
        } else {
        }
    };

    const handleChatBox = () => {
        if (!bankNoInput || !String(bankNoInput).trim()) {
            setResponseMessage({
                ErrorCode: '1000',
                ErrorDescription: 'Lütfen önce bir ürün seçiniz!...'
            });
            setUyariTip('error');
            setUyari(true);
            return;
        }

        setTeknisyenKocuPopUp(true);
    };

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') return;
        setUyari(false);
    };

    return (
        <Page className={classes.root} title={"Teknisyen Koçu"}>
            <Container maxWidth="lg">
                <Header />
                <Backdrop className={classes.backdrop} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar
                    open={uyari}
                    autoHideDuration={10000}
                    onClose={uyariKapat}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={uyariKapat} severity={uyariTip}>
                        {responseMessage.ErrorDescription}
                    </Alert>
                </Snackbar>
                <Card>
                    <CardContent>
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <ContactSupportIcon style={{ fontSize: 48, color: '#FF9800' }} />
                            <Typography variant="h6" className={classes.mt1}>
                                Teknisyen Koçu
                            </Typography>
                        </Box>
                    </CardContent>
                    <Divider />
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={2} />
                            <Grid item xs={12} md={8}>
                                <Autocomplete
                                    className={classes.autocompleteFix}
                                    options={productsData || []}
                                    getOptionLabel={(option) => option.TANIM || ''}
                                    value={selectedProduct || null}
                                    inputValue={productInputValue}
                                    onInputChange={(e, newValue, reason) => {
                                        setProductInputValue(newValue ?? "");
                                        if (reason === "input" && (newValue?.length ?? 0) > 2) {
                                            handleGetProductsBySearchTerm(newValue);
                                        }
                                        if (reason === "clear") {
                                            handleChangeSelectedProduct(e, null);
                                            setProductInputValue("");
                                            setBankNoInput("");
                                        }
                                    }}
                                    onChange={(event, newValue) => {
                                        handleChangeSelectedProduct(event, newValue);
                                        setProductInputValue(newValue ? newValue.ACIKLAMA : "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Ürün Ara"
                                            placeholder="Ürün Model Kodu ya da açıklaması ile arama yapabilirsiniz..."
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {productLoading ? <CircularProgress size={18} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} />
                            <Grid item xs={12} md={4} />
                            <Grid item xs={12} md={4}>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    className={classes.centerText}
                                >
                                    Destek almak istediğiniz ürünü listeden aratarak sohbeti başlatabilirsiniz.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={4} />
                            <Grid item xs={12} md={4} />
                            <Grid item xs={12} md={4}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    fullWidth
                                    className={classes.button}
                                    onClick={handleChatBox}
                                >
                                    SOHBETİ BAŞLAT
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={4} />
                        </Grid>
                    </CardContent>
                </Card>
                {teknisyenKocuPopUp && (
                    <TeknisyenKocuDialog
                        open={teknisyenKocuPopUp}
                        onClose={() => setTeknisyenKocuPopUp(false)}
                        fisNo={selectedProduct.MODEL_KODU}
                        KUL_MODEL_KODU={selectedProduct.KUL_MODEL_KODU}
                        KulModelKoduAciklama={selectedProduct.ACIKLAMA}
                        isValidateReceipt={0}
                    />
                )}
            </Container>
        </Page>
    );
};

export default TeknisyenKocuChat;
